import Vue from 'vue';
import VideoTrailer from '../../video-trailer/index.vue'
import CourseBladesButtons from '@/components/features/course-blades-buttons/index.vue'
import CourseBladesStatistic from '@/components/features/course-blades-statistic/index.vue'

import vueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(vueSmoothScroll)

export default {
    name: 'course-headers-blade-full-left',
    props: {
        item: {},
        courseInfo: {}
    },
    components: {
        VideoTrailer,
        CourseBladesButtons,
        CourseBladesStatistic
    },
}
